import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import mlbSealingAvatar from '#src/components/sealing/assets/mlbSealingAvatar.webp';
import sealingAvatar from '#src/components/sealing/assets/sealingAvatar.webp';

const SealingAvatar = styled.img`
  width: var(--avatar-size, calc(10 * var(--unit)));
  height: var(--avatar-size, calc(10 * var(--unit)));
`;

const sealingAvatarImgBySport = {
  [Sport.BASEBALL]: mlbSealingAvatar,
  [Sport.FOOTBALL]: sealingAvatar,
  [Sport.NBA]: sealingAvatar,
};

export const SealingGenericAvatar = ({ className }: { className?: string }) => {
  const { sport } = useSportContext();
  return (
    <SealingAvatar className={className} src={sealingAvatarImgBySport[sport]} />
  );
};
